import React from 'react';
import './FreshnessIndicator.css';

/**
 * Shows how recently an investment was updated.
 * updateSource: 'auto' (cron-updated) | 'manual'
 */
function FreshnessIndicator({ timeOfUpdate, updateSource = 'manual' }) {
  if (!timeOfUpdate) return null;

  const daysSince = Math.floor((Date.now() - new Date(timeOfUpdate)) / 86400000);

  let level, label;
  if (daysSince < 1) {
    level = 'fresh';
    label = updateSource === 'auto' ? 'Auto-updated today' : 'Updated today';
  } else if (daysSince < 7) {
    level = 'recent';
    label = `${daysSince}d ago`;
  } else if (daysSince < 30) {
    level = 'warning';
    label = `${daysSince}d ago`;
  } else {
    level = 'stale';
    label = `Stale — ${daysSince}d ago`;
  }

  return (
    <span className={`freshness freshness--${level}`} title={`Last updated: ${new Date(timeOfUpdate).toLocaleDateString()}`}>
      <span className="freshness__dot" />
      {label}
    </span>
  );
}

export default FreshnessIndicator;
